<div class="container mt-5">
  @if (isTherapist) {
    <div class="therapist-badge">
      Therapist Account - no access to submit an order to production
    </div>
    @if (!therapistCanSubmit) {
      <div class="therapist-notice">
        <strong>Therapist</strong> can fill and save order, then submit to a dealer from the drop down menu option in the upper right corner of this screen

      </div>
    }
  }
  <div [style.display]="showSummary ? 'none' : 'block'">
    <div class="d-flex justify-content-center">
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">

        <!-- Passo 1 -->
        <li class="nav-item" role="presentation">
          <button
            #step1Tab
            class="nav-link btn-tab active show"
            id="pills-step1-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-step1"
            type="button"
            role="tab"
            aria-controls="pills-step1"
            aria-selected="true"
            (click)="onTabClick(1, 'pills-step1-tab')"
            [disabled]="currentStep < 1"
          >
            <div class="step-content">
              <svg
                class="step-icon"
                width="80"
                height="118"
                viewBox="0 0 80 118"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_280_3324)">
                  <g clip-path="url(#clip1_280_3324)">
                    <path
                      d="M14.8755 21.8208C14.7089 24.4298 14.7422 32.9758 14.9255 36.9896L15.092 40.4682L13.9094 42.5922C11.2778 47.3084 7.86338 54.6837 6.01458 59.6508C5.58152 60.8048 4.73208 62.8284 4.09915 64.1663C2.76669 67.0596 2.5335 67.9627 2.63344 69.9863C2.73337 72.2942 3.0998 72.8796 6.41432 76.2913C10.1286 80.0877 12.477 82.128 16.7409 85.3056C18.723 86.7773 20.3886 88.0317 20.4719 88.0818C20.805 88.3996 22.1208 97.2634 22.4206 101.21C22.6871 104.689 22.4206 106.846 21.4879 108.703C20.9715 109.723 20.2553 110.241 17.5071 111.596C14.9921 112.834 12.8435 113.586 11.028 113.837C9.56227 114.038 8.87938 114.339 8.47964 114.958C8.12987 115.493 8.31308 116.095 8.96266 116.58C9.37906 116.881 9.72883 116.931 12.2439 116.998C15.3918 117.081 19.689 116.831 21.6711 116.429C22.6371 116.245 23.7697 116.195 25.7851 116.229C28.3667 116.279 28.5832 116.262 29.033 115.928C29.6326 115.476 30.0823 114.59 30.0823 113.82C30.0823 113.486 29.8657 112.666 29.5993 111.981C29.3328 111.312 28.933 110.124 28.7332 109.355C28.3667 108.017 28.3667 107.85 28.5499 105.676C28.7165 103.552 29.466 97.7317 29.6825 96.7951L29.7825 96.377L30.2488 96.9289C30.8818 97.6815 31.8311 100.14 33.1636 104.488C34.6127 109.171 35.1123 110.475 35.8452 111.312C36.3449 111.914 36.5281 112.014 37.0611 112.014C37.4608 112.014 37.8772 111.88 38.1437 111.663C38.5434 111.345 38.5768 111.211 38.5768 110.124C38.5768 109.455 38.3436 107.616 38.0771 106.01C37.3442 101.712 37.4108 99.3204 38.3269 95.9589C38.8432 94.0691 38.5268 92.5639 37.4775 91.8615C37.1943 91.6608 36.3116 91.3263 35.5121 91.1256C33.8465 90.6741 32.4807 89.8546 31.3648 88.6003L30.6319 87.7808L30.532 84.3022C30.4154 80.5894 30.2155 79.2013 29.4993 77.3115C28.5 74.6523 28.5166 74.7861 28.5333 71.7925C28.5333 69.3341 28.5832 68.6818 28.983 66.9091C29.6159 64.0158 31.1649 58.5135 32.8471 53.1451C35.5121 44.666 35.7453 43.8632 36.095 42.0236C36.6114 39.3477 36.4948 36.8391 35.6953 33.4942C34.7792 29.6477 34.2462 25.2827 34.2462 21.6034V20.0313H24.6192H14.9754L14.8755 21.8208ZM32.8471 20.6334L33.6966 20.7337L33.7965 23.443C33.8184 23.9878 33.8452 24.5158 33.8775 25.0312C34.0913 28.4406 34.5484 31.302 35.4455 34.8322C35.7453 36.053 35.8119 36.7889 35.8119 38.7623C35.8119 41.4048 35.6453 42.3413 34.4794 46.121L33.8798 48.0442L25.2854 47.4254C20.5385 47.091 16.5244 46.8067 16.3245 46.8067C15.9914 46.7899 15.9748 46.6561 15.7749 43.3949C15.2752 34.7486 15.1087 26.5203 15.3752 22.3225L15.4751 20.533H23.7364C28.2834 20.533 32.3808 20.5832 32.8471 20.6334ZM15.2919 43.8967C15.3419 44.8499 15.3752 45.6192 15.3585 45.6192C14.9754 45.5523 13.4098 44.967 13.3931 44.8834C13.3598 44.5823 15.0087 41.8061 15.1087 41.9901C15.1753 42.1072 15.2586 42.9601 15.2919 43.8967ZM17.2073 69.8525L17.174 72.8461L16.4245 72.1437C16.0081 71.7423 15.4584 71.2908 15.2086 71.1235L14.7589 70.8225L15.4418 69.5515C16.0581 68.4477 17.0741 66.8589 17.1906 66.8589C17.2073 66.8589 17.2073 68.2135 17.2073 69.8525Z"
                      fill="black"
                    />
                    <path
                      d="M33.9999 20.5312H15.4999C15.3333 27.0312 15.5999 43.8313 15.9999 49.0312M34.9999 43.5312L31.4999 53.0312"
                      stroke="black"
                      stroke-width="2"
                    />
                    <path
                      d="M15.5 41.0312L11.5 50.0312"
                      stroke="black"
                      stroke-width="2"
                    />
                  </g>
                  <path
                    d="M35 36.5312L33.5 23.5312V20.5312L36 21.0312L37.5 31.0312L38 44.0312H35V42.0312V36.5312Z"
                    fill="white"
                  />
                </g>
                <g clip-path="url(#clip2_280_3324)">
                  <path
                    d="M52.8674 24.8327C49.1713 22.6988 44.4357 23.9673 42.3016 27.6638C40.1674 31.3603 41.4362 36.0955 45.1327 38.2297C48.8292 40.3639 53.5644 39.0951 55.6986 35.3986C57.8327 31.7021 56.5639 26.9669 52.8674 24.8327ZM45.8362 37.0112C42.8159 35.2674 41.7765 31.3873 43.5201 28.3673C45.2636 25.3474 49.144 24.3076 52.1639 26.0512C55.1839 27.7948 56.2236 31.6751 54.4801 34.6951C52.7365 37.715 48.8561 38.7548 45.8362 37.0112Z"
                    fill="black"
                  />
                  <path
                    d="M61.9488 40.7609C61.7899 40.2064 61.8658 39.625 62.1541 39.1257C62.4423 38.6264 62.9079 38.2701 63.4675 38.1304L66.3907 37.3986C67.331 37.1621 67.9862 36.3225 67.988 35.3492L67.9872 27.7005C67.9854 26.7333 67.3272 25.8905 66.3899 25.6578L63.4662 24.9279C62.9044 24.7903 62.4437 24.435 62.1494 23.9322C61.8612 23.4329 61.7887 22.8553 61.9482 22.2978L62.7739 19.4052C63.044 18.4732 62.6403 17.485 61.8 16.9999L55.1749 13.1749C54.3346 12.6897 53.2769 12.8342 52.6049 13.5341L50.5126 15.6955C50.1096 16.1123 49.5731 16.3384 48.9966 16.3384C48.4201 16.3385 47.8796 16.1076 47.4759 15.6959L45.3819 13.5289C44.7118 12.8335 43.6528 12.6848 42.8143 13.1669L36.1899 16.9906C35.3514 17.4726 34.9484 18.466 35.2137 19.3986L36.0416 22.296C36.2004 22.8505 36.1246 23.4318 35.8363 23.9312C35.548 24.4305 35.0825 24.7868 34.5228 24.9265L31.5997 25.6583C30.6594 25.8948 30.0041 26.7344 30.0024 27.7077L30.0031 35.3564C30.005 36.3236 30.6631 37.1664 31.6005 37.3991L34.5241 38.129C35.086 38.2666 35.5467 38.6219 35.841 39.1247C36.1292 39.624 36.2016 40.2016 36.0422 40.7591L35.2165 43.6517C34.9463 44.5837 35.3501 45.5719 36.1904 46.057L42.8155 49.882C43.6558 50.3672 44.7135 50.2227 45.3855 49.5228L47.4777 47.3614C47.8808 46.9446 48.4173 46.7185 48.9937 46.7185C49.5702 46.7184 50.1108 46.9493 50.5145 47.361L52.6084 49.528C53.2786 50.2234 54.3376 50.3721 55.1761 49.89L61.8005 46.0663C62.639 45.5843 63.042 44.5909 62.7766 43.6583L61.9488 40.7609ZM61.1021 44.843L54.4778 48.6667C54.1971 48.8294 53.8441 48.7799 53.6219 48.546L51.528 46.3791C50.8639 45.6871 49.9638 45.3055 48.9966 45.3073C48.0294 45.3091 47.1373 45.6871 46.4688 46.381L44.3765 48.5424C44.1513 48.7777 43.7988 48.8258 43.5186 48.6641L36.8936 44.8391C36.6134 44.6774 36.4789 44.348 36.5701 44.0353L37.3958 41.1427C37.6624 40.2168 37.5376 39.2517 37.0617 38.4167C36.751 37.8719 36.3047 37.4357 35.781 37.1333C35.5009 36.9716 35.1936 36.8429 34.8704 36.7699L31.9467 36.04C31.6331 35.9645 31.4137 35.6836 31.4143 35.3591L31.4136 27.7104C31.4141 27.386 31.6325 27.1061 31.946 27.0273L34.8691 26.2955C35.7998 26.0616 36.5787 25.472 37.0568 24.6439C37.5349 23.8157 37.6561 22.8465 37.3933 21.9235L36.5655 19.0261C36.477 18.7152 36.6102 18.3861 36.8909 18.2234L43.5152 14.3997C43.7959 14.237 44.1489 14.2865 44.3711 14.5204L46.4651 16.6873C47.1291 17.3792 48.0292 17.7609 48.9964 17.7591C49.954 17.7599 50.8557 17.3793 51.5243 16.6854L53.6165 14.524C53.8417 14.2887 54.1943 14.2405 54.4744 14.4023L61.0995 18.2273C61.3796 18.389 61.5142 18.7184 61.423 19.0311L60.5973 21.9237C60.3306 22.8496 60.4554 23.8147 60.9313 24.6497C61.4108 25.4786 62.1913 26.0673 63.1252 26.3061L66.0488 27.036C66.3685 27.115 66.5818 27.3924 66.5813 27.7169L66.582 35.3656C66.5814 35.69 66.363 35.9699 66.0496 36.0487L63.1265 36.7805C62.1957 37.0144 61.4169 37.604 60.9388 38.4321C60.4607 39.2603 60.3395 40.2295 60.6023 41.1525L61.4301 44.0499C61.5185 44.3608 61.3854 44.6899 61.1047 44.8526L61.1021 44.843Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_280_3324">
                    <rect
                      width="45"
                      height="97"
                      fill="white"
                      transform="translate(0.5 20.0312)"
                    />
                  </clipPath>
                  <clipPath id="clip1_280_3324">
                    <rect
                      width="35.9766"
                      height="97"
                      fill="white"
                      transform="translate(2.6001 20.0312)"
                    />
                  </clipPath>
                  <clipPath id="clip2_280_3324">
                    <rect
                      width="45"
                      height="45"
                      fill="white"
                      transform="translate(40.7644 0.795654) rotate(30)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="step-info">
                <span class="step-number">1</span>
                <span class="step-label">Order Detail</span>
              </div>
            </div>
          </button>
        </li>

        <!-- Passo 2 -->
        <li class="nav-item" role="presentation">
          <button
            #step2Tab
            class="nav-link btn-tab"
            id="pills-step2-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-step2"
            type="button"
            role="tab"
            aria-controls="pills-step2"
            aria-selected="false"
            (click)="onTabClick(2, 'pills-step2-tab')"
            [disabled]="currentStep < 2"
          >
            <div class="step-content">
              <svg
                class="step-icon"
                style="left: 90px"
                width="86"
                height="71"
                viewBox="0 0 86 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_280_3303)">
                  <path
                    d="M21.8022 17.3443C21.8022 18.1227 21.1706 18.7543 20.3922 18.7543C19.6138 18.7543 18.9822 18.1227 18.9822 17.3443V10.5587C18.9822 10.353 19.0263 10.1621 19.1034 9.98585L22.1878 1.47415C22.353 0.882977 22.9001 0.449707 23.5427 0.449707H61.3996C61.9761 0.453379 62.5159 0.809554 62.7215 1.37866L65.8389 9.9781L65.8426 9.98544L65.8499 10.0038L65.8573 10.0185L65.8646 10.0368L65.8683 10.0442L65.872 10.0552L65.8793 10.0736L65.883 10.0809L65.8867 10.0919L65.894 10.1103V10.114L65.8977 10.1286L65.905 10.147V10.1507L65.9087 10.1654L65.916 10.1837L65.9234 10.2168L65.9271 10.2351L65.9307 10.2498V10.2535L65.9344 10.2718L65.9381 10.2865V10.2902L65.9417 10.3086L65.9454 10.3196V10.3269L65.9491 10.3453V10.3636L65.9528 10.382V10.4004L65.9564 10.4187V10.4371L65.9601 10.4554V48.4189C65.9601 49.1974 65.3285 49.8289 64.5501 49.8289H20.385C19.6065 49.8289 18.975 49.1974 18.975 48.4189V27.7538C18.975 26.9754 19.6065 26.3438 20.385 26.3438C21.1634 26.3438 21.795 26.9754 21.795 27.7538V47.0089H63.1401V11.9751H49.6793V22.7373C49.6793 23.5158 49.0477 24.1473 48.2693 24.1473C47.9241 24.1473 47.6084 24.0225 47.3624 23.8169L42.2805 20.2662L37.518 23.8573C36.8975 24.3236 36.0126 24.2024 35.5462 23.5819C35.3553 23.3285 35.2635 23.0311 35.2635 22.7337L35.2598 11.9715H21.7951V17.3471L21.8022 17.3443ZM7.37164 56.2736C9.2149 56.2736 10.8819 57.019 12.09 58.2271L12.1707 58.3152C13.0189 59.1928 13.6248 60.3017 13.8928 61.5354H36.0525C36.3279 60.2612 36.9669 59.123 37.8591 58.2307C39.0634 57.019 40.7341 56.2736 42.5738 56.2736C44.4171 56.2736 46.0841 57.019 47.2921 58.2271L47.3729 58.3152C48.2211 59.1928 48.8269 60.3017 49.095 61.5354H72.103C72.3784 60.2612 73.0173 59.123 73.9096 58.2307C75.1139 57.019 76.7846 56.2736 78.6243 56.2736C80.4676 56.2736 82.1346 57.019 83.3426 58.2271L83.4234 58.3152C84.5837 59.5159 85.296 61.1499 85.296 62.9454C85.296 64.7887 84.5506 66.4557 83.3426 67.6637L83.2544 67.7445C82.0537 68.9012 80.4234 69.6172 78.6242 69.6172C76.781 69.6172 75.114 68.8718 73.9059 67.6637L73.8251 67.5756C72.9806 66.698 72.3711 65.5891 72.103 64.3554H49.095C48.8196 65.6331 48.1807 66.7752 47.2921 67.6637C46.084 68.8717 44.417 69.6172 42.5737 69.6172C40.7305 69.6172 39.0635 68.8718 37.8554 67.6637C36.9668 66.7751 36.3242 65.6331 36.0525 64.3554H13.8928C13.6174 65.6295 12.9785 66.7678 12.0898 67.6601C10.8818 68.8718 9.21478 69.6208 7.37151 69.6208C5.53554 69.6208 3.86484 68.8718 2.65679 67.6638C1.44505 66.4594 0.699707 64.7887 0.699707 62.949C0.699707 61.1131 1.4451 59.446 2.65318 58.238L2.66053 58.2306C3.86858 57.0263 5.5356 56.2809 7.36789 56.2809L7.37164 56.2736ZM10.0962 60.2209C9.3985 59.5233 8.43642 59.0936 7.37164 59.0936C6.30309 59.0936 5.34108 59.5232 4.64713 60.2172C3.94948 60.9149 3.51983 61.8806 3.51983 62.9454C3.51983 64.0103 3.95311 64.9723 4.64713 65.6699C5.34111 66.3676 6.30317 66.7972 7.37164 66.7972C8.4365 66.7972 9.39851 66.3639 10.0962 65.6699C11.5759 64.1975 11.6016 61.7887 10.1622 60.2833L10.0962 60.2209ZM81.3528 60.2209C80.6552 59.5233 79.6931 59.0936 78.6283 59.0936C77.5636 59.0936 76.6015 59.5269 75.9038 60.2209C74.4167 61.6933 74.402 64.1021 75.8414 65.6076L75.9038 65.6663C76.6015 66.364 77.5636 66.7936 78.6283 66.7936C79.6638 66.7936 80.6002 66.386 81.2904 65.7288L81.3492 65.6663C82.0468 64.9687 82.4765 64.0066 82.4765 62.9418C82.4765 61.9063 82.0726 60.9663 81.4153 60.2797L81.3492 60.2173L81.3528 60.2209ZM45.3023 60.2209C44.6046 59.5233 43.6426 59.0936 42.5778 59.0936C41.513 59.0936 40.5509 59.5269 39.8533 60.2209C38.3441 61.719 38.3551 64.1719 39.8533 65.6699C40.5509 66.3676 41.513 66.7972 42.5778 66.7972C43.6426 66.7972 44.6046 66.3639 45.3023 65.6699C46.7784 64.1938 46.8115 61.7924 45.3684 60.2833L45.3023 60.2209ZM38.7847 3.2663L38.2266 9.14498H46.7344L46.1762 3.2663H38.7847ZM35.4029 9.14498L35.961 3.2663H24.5306L22.3973 9.14498H35.4029ZM48.9961 3.2663L49.5542 9.14498H62.5529L60.4195 3.2663H48.993H48.9961ZM26.4173 44.4132C25.6389 44.4132 25.0073 43.7817 25.0073 43.0032C25.0073 42.2248 25.6389 41.5932 26.4173 41.5932H32.4392C33.2176 41.5932 33.8492 42.2248 33.8492 43.0032C33.8492 43.7817 33.2176 44.4132 32.4392 44.4132H26.4173ZM46.8701 11.9684H38.0905V19.9035L41.4062 17.3993C41.8799 17.0468 42.5482 17.0137 43.0586 17.3699L46.87 20.0284V11.9616L46.8701 11.9684ZM21.8058 22.6499C21.8058 23.4283 21.1742 24.0599 20.3958 24.0599C19.6174 24.0599 18.9858 23.4283 18.9858 22.6499V22.4406C18.9858 21.6621 19.6174 21.0306 20.3958 21.0306C21.1742 21.0306 21.8058 21.6621 21.8058 22.4406V22.6499Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_280_3303">
                    <rect
                      width="86"
                      height="70"
                      fill="white"
                      transform="translate(0 0.03125)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="step-info">
                <span class="step-number">2</span>
                <span class="step-label">Choose Product</span>
              </div>
            </div>
          </button>
        </li>
        
        <!-- Passo 3 -->
        <li class="nav-item" role="presentation">
          <button
            #step3Tab
            class="nav-link btn-tab"
            id="pills-step3-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-step3"
            type="button"
            role="tab"
            aria-controls="pills-step3"
            aria-selected="false"
            (click)="onTabClick(3, 'pills-step3-tab')"
            [disabled]="currentStep < 3"
          >
            <div class="step-content">
              <svg
                class="step-icon"
                style="width: 60px; left: 90px"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 122.88 82.26"
              >
                <title>measurement</title>
                <path
                  d="M122.88,39.45V79.56a2.7,2.7,0,0,1-.76,1.87l-.08.08a2.67,2.67,0,0,1-1.86.75H2.7A2.74,2.74,0,0,1,.83,81.5l-.12-.13A2.72,2.72,0,0,1,0,79.56V39.45a2.74,2.74,0,0,1,.76-1.87l.13-.12a2.72,2.72,0,0,1,1.81-.71H120.18a2.68,2.68,0,0,1,1.87.76l.07.07a2.68,2.68,0,0,1,.76,1.87ZM107.07,77.2V58.13h5.06V77.2h5.69V41.81H5.06V77.2h5.69V66.69h5.06V77.2h5.64V58.13h5.06V77.2h5.65V66.69h5.05V77.2h5.65V58.13h5V77.2h5.65V66.69h5V77.2h5.65V58.13h5.06V77.2H75V66.69H80V77.2h5.64V58.13h5.06V77.2h5.65V66.69h5V77.2ZM122.31,24a3.2,3.2,0,1,1-6.4-.08l.32-20.74a3.21,3.21,0,0,1,6.41.07L122.31,24ZM6.65,24a3.21,3.21,0,1,1-6.41-.08L.56,3.17A3.21,3.21,0,1,1,7,3.24L6.65,24Zm94.12.27a3.21,3.21,0,0,1-4.2-4.85l3-2.61H23.28l3,2.61a3.21,3.21,0,0,1-4.2,4.85L12.57,16a3.2,3.2,0,0,1-.33-4.52l.3-.3,9.27-8.26a3.22,3.22,0,1,1,4.28,4.8l-3,2.64H99.77l-3-2.64a3.22,3.22,0,0,1,4.28-4.8l9.28,8.26.29.3a3.2,3.2,0,0,1-.33,4.52l-9.54,8.26Z"
                />
              </svg>
              <div class="step-info">
                <span class="step-number">3</span>
                <span class="step-label">Measure</span>
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>

    <!-- Conteúdo das Abas -->
    <div class="tab-content mt-5" id="pills-tabContent">
      <div
        class="tab-pane fade active show"
        id="pills-step1"
        role="tabpanel"
        aria-labelledby="pills-step1-tab"
        style="background-color: #f8f4f4"
      >
        <app-order-flow-order-detail
          [isDuplicateAction]="isDuplicateAction"
          [baseOrderNumber]="baseOrderNumber"
        ></app-order-flow-order-detail>
      </div>
      <div
        class="tab-pane"
        id="pills-step2"
        role="tabpanel"
        aria-labelledby="pills-step2-tab"
      >
        <app-order-flow-product-choice
          [isDuplicateAction]="isDuplicateAction"
          [baseOrderNumber]="baseOrderNumber"
        ></app-order-flow-product-choice>
      </div>
      <div
        class="tab-pane"
        id="pills-step3"
        role="tabpanel"
        aria-labelledby="pills-step3-tab"
      >
        <app-order-flow-measure
          [productName]="productNameSelected"
        ></app-order-flow-measure>
      </div>
    </div>
  </div>

  <div [style.display]="showSummary ? 'block' : 'none'">
    <div class="d-flex justify-content-center">
      <!-- Exibe o resumo se a variável showSummary for verdadeira -->
      <div class="order-summary">
        <app-order-flow-order-summary
          [orderDetail]="orderDetailSummary"
          [measurements]="filledMeasurements"
          [accessories]="filledAccessories"
        ></app-order-flow-order-summary>
      </div>
    </div>
  </div>
  <!-- Botões de Ação -->
  <!-- Action Buttons -->
  <div class="mt-3 mb-5 action-container">
    @if (showSummary) {
      @if (!hideBtnSubmit) {
        <button
          type="button"
          class="j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2 mtm-mr"
          style="margin-right: 10px; font-size: 18px; border: none"
          (click)="submitOrder()"
          [disabled]="isLoading"
        >
          Submit Order
        </button>
      }
    }

    @if (!showSummary) {
      <button
        type="button"
        class="btn-continue j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2 mtm-mr"
        style="font-size: 18px; border: none;"
        [style.opacity]="orderStatus === 'SavePurchaseOrder' ? 0.3 : 1"
        (click)="onContinue()"
        [disabled]="isLoading || this.orderStatus === 'SavePurchaseOrder'">
        Continue
      </button>
    }

    @if (!showSummary) {
    <button
      type="button"
      class="btn-save-return j7 j8 an j9 ja bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2 mtm-mr"
      style="
        font-size: 18px;
        border: 1px solid #00b4e6;
        color: #00b4e6;
        background-color: none;
      "
      [disabled]="isLoading"
      (click)="save()"
    >
      {{ btnSaveLabel }}
    </button>
  }
    @if (!hideBtnCancel && !isQuote) {
      <button
      type="button"
      class="btn-save-return j7 j8 an j9 ja bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2 mtm-mr"
      style="
        font-size: 18px;
        border: 1px solid #00b4e6;
        color: #00b4e6;
        background-color: none;
      "
      (click)="onCancel()"
      >
      {{ currentStep === 1 ? 'Cancel' : 'Back' }}
      </button>
    }
  </div>

  <!-- Loading Overlay -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

    <div *ngIf="isLoadingChange" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>